import { Action } from '@ngrx/store';

export const INFORMATION = '[Logger] INFORMATION';
export const ERROR = '[Logger] ERROR';
export const WARNING = '[Logger] WARNING';

export class InformationLogEntry implements Action {
  public readonly type = INFORMATION;
  constructor(
    public readonly message: string,
    public readonly properties?: { [name: string]: string },
  ) {}
}

export class WarningLogEntry implements Action {
  public readonly type = WARNING;
  constructor(
    public readonly message: string,
    public readonly properties?: { [name: string]: string },
  ) {}
}

export class ErrorLogEntry implements Action {
  public readonly type = ERROR;
  public readonly error: Record<string, any>;
  constructor(error: Error | string, public readonly properties?: { [name: string]: string }) {
    // Make error friendly for redux
    let errorObj: Record<string, any> | undefined;
    try {
      errorObj = JSON.parse(
        error instanceof Error
          ? JSON.stringify(error, Object.getOwnPropertyNames(error), 2)
          : error,
      );
    } catch (er) {
      try {
        errorObj =
          typeof error === 'string'
            ? { message: error }
            : {
                name: error.name,
                message: error.message,
              };
      } catch (err) {}
    }
    this.error = errorObj ?? { message: 'error serializing error for redux store' };
  }
}

export type All = InformationLogEntry | WarningLogEntry | ErrorLogEntry;
